// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { alliedUniversityArticleViewStyles } from "@awc/App/Widgets/AlliedUniversityArticleView/AlliedUniversityArticleView";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color } from "@awc/XDL/Utilities";
import { css } from "styled-components";


alliedUniversityArticleViewStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 16px;
        color: ${color("common.ui29")};
    `,
};

alliedUniversityArticleViewStyles.title = {
    variant: "h3",
    css: css`
        margin-bottom: 16px;
    `,
};

alliedUniversityArticleViewStyles.articlesContainer = {
    css: css`
        .swiper-slide {
            width: 240px;
        }
    `,
};

alliedUniversityArticleViewStyles.articleContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        position: relative;
        height: 240px;
    `,
};

alliedUniversityArticleViewStyles.articleInfo = {
    css: css`
        position: absolute;
        bottom: 8px;
        right: 8px;
        left: 8px;
        display: flex;
        flex-direction: column;
        row-gap: 8px;
    `,
};

alliedUniversityArticleViewStyles.articleTitle = {
    color: "common.ui14",
    typographyProps: {
        size: fontConfig.fontSize.singleLineRegular,
        css: css`
            line-height: ${fontConfig.lineHeight.singleLineRegular};
        `,
    },
};

alliedUniversityArticleViewStyles.articleQuickSummaryDisplay = {
    color: "common.white",
    css: css`
        margin-bottom: 16px;
        &, p {
            display: inline;
        }
    `,
};


alliedUniversityArticleViewStyles.articleImage = {
    height: "240px",
    css: css`
        img {
            width: auto;
            height: auto;
            max-height: 100%;
            object-fit: contain;
        }
    `,
};